import { useLocation } from "react-router-dom"

export const useIsLoginPage = () => {
  const pathname = useLocation().pathname
  const isLoginPage = pathname.includes("login")
  return isLoginPage
}
